<template>
	<div class="clock-container" :class="{ expanded: isActive }" @click="toggleActive">
		<div class="clock-row">
			<div class="clock-chart-mini">
				<DoughnutChart :chartData="testData" :options="options" class="chart" />
			</div>
			<div class="clock-titles">
				<span class="clock-subtitle">{{ clock.type }}</span>
				<span class="clock-title">{{ clock.name }}</span>
			</div>
			<o-icon pack="mdi" class="chevron" icon="chevron-down" />
		</div>
		<div v-if="isActive" class="clock-summary">
			{{ clock.description }}
		</div>
	</div>
</template>

<script lang="ts">
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

Chart.defaults.plugins.tooltip.enabled = false;
Chart.defaults.plugins.legend.display = false;
Chart.defaults.animation = {
	delay: 100,
	duration: 1000,
	easing: "easeInOutExpo",
	loop: false,
};

import { computed, defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import { onEscape } from "@/utils/escape";
import { DoughnutChart } from "vue-chart-3";

export default defineComponent({
	name: "Clock",
	components: { DoughnutChart },
	props: {
		clock: {
			type: Object,
			required: true,
		},
		animate: {
			type: Boolean,
			required: true,
		},
		animationDelay: {
			type: String,
			required: false,
		},
	},
	setup(props) {
		const dataArray: number[] = [];
		const colorArray: string[] = [];
		for (let index = 0; index < props.clock.max; index++) {
			dataArray.push(1);

			if (index < props.clock.value) {
				colorArray.push(props.clock.color);
			} else {
				colorArray.push("#AAA");
			}
		}
		const data = ref(dataArray);
		const animation = !props.animate ? null : { delay: parseInt(props.animationDelay) };
		const options = ref({
			responsive: true,
			cutout: "35%",
			devicePixelRatio: 2,
			animation,
		});

		const testData = computed(() => ({
			datasets: [
				{
					data: data.value,
					backgroundColor: colorArray,
				},
			],
		}));

		const isActive = ref(false);

		function toggleActive() {
			isActive.value = !isActive.value;
		}

		// Esc collapses an expanded clock
		let offEscape;
		onMounted(
			() =>
				(offEscape = onEscape(() => (isActive.value ? ((isActive.value = false), true) : false)))
		);
		onBeforeUnmount(() => offEscape?.());

		return { testData, options, isActive, toggleActive };
	},
});
</script>
